{
  "manager": {
    "tableCurrentlyIn": {
      "scanOut": "Scan Out",
      "name": "Name",
      "memberId": "Member ID",
      "scannedInAt": "Scanned In At"
    },
    "scanHistory": {
      "title": "Scan History",
      "scanInOut": "Scan In/Out",
      "stillIn": "Still in",
      "dateRange": "Date Range",
      "search": "Search",
      "searchPlaceholder": "Search by name or member ID"
    },
    "scanIndex": {
      "title": "Scan In/Out",
      "viewHistory": "View History",
      "scanPlaceholder": "Scan barcode or enter User ID / Member ID",
      "scanning": "Scanning...",
      "scan": "Scan",
      "scannedIn": "scanned in",
      "scannedOut": "scanned out",
      "usePhoneScanner": "Use your phone as a camera scanner",
      "hideQrCode": "Hide QR code",
      "showQrCode": "Show QR code",
      "qrCodeAlt": "Mobile Scanner QR Code",
      "qrCodeInstructions": "Scan this QR code with your phone to open a camera-based scanner.",
      "generating": "Generating...",
      "currentlyIn": "Currently In",
      "noneScannedIn": "No one currently scanned in.",
      "todaysActivity": "Today's Activity",
      "noActivityToday": "No activity today.",
      "loadFailed": "Failed to load scan records. Please try again.",
      "scanFailed": "Scan failed. Please try again.",
      "scanOutFailed": "Scan out failed.",
      "mobileLinkFailed": "Failed to generate mobile scanner link."
    },
    "mobileScanner": {
      "retryCamera": "Retry Camera",
      "scannedIn": "scanned in",
      "scannedOut": "scanned out",
      "identifierPlaceholder": "Enter User ID or Member ID",
      "scanning": "Scanning...",
      "scan": "Scan",
      "recentScans": "Recent Scans",
      "badgeIn": "In",
      "badgeOut": "Out",
      "title": "Mobile Scanner",
      "scanFailed": "Scan failed.",
      "cameraPermissionDenied": "Camera permission denied. Please grant camera access or use manual input below.",
      "cameraNotFound": "No camera found on this device. Please use manual input below.",
      "cameraUnavailable": "Unable to access camera. Please use manual input below.",
      "noSessionToken": "No scan session token provided. Please generate a new QR code from the Scan In/Out page."
    },
    "tableTodayActivity": {
      "name": "Name",
      "memberId": "Member ID",
      "scannedIn": "Scanned In",
      "scannedOut": "Scanned Out",
      "stillIn": "Still in"
    }
  }
}
